import { RecommendedProductFamily } from '@omniafishing/core';
import { useEffect, useState } from 'react';
import { LoadingState } from '../../../constants/loading_state';
import { apiV1 } from '../../../lib/api';

export const useFetchWaterbodyTechniqueRecommendations = (
  slug: string,
  selectedSpeciesName: string,
  selectedTechniqueName: string,
  selectedSeasonNames: string | string[]
) => {
  const [recommendedProductFamilies, setRecommendedProductFamilies] = useState<
    RecommendedProductFamily[]
  >([]);
  const [recommendationsLoadingState, setRecommendationsLoadingState] = useState<LoadingState>(
    LoadingState.NOT_STARTED
  );

  useEffect(() => {
    let ignore = false;

    // initially selectedTechnique is derived from selectedSeason and selectedSpecies
    // so we don't want to fetch technique data until we have a derived selectedTechnique
    if (!selectedTechniqueName) {
      return;
    }

    async function fetchRecommendedFamilies() {
      setRecommendationsLoadingState(LoadingState.PENDING);

      const recommendationsResult = await apiV1.waterbodyRecommendationsFetch(slug, {
        species: selectedSpeciesName,
        styles: selectedTechniqueName,
        seasons: selectedSeasonNames,
      });

      if (!ignore) {
        setRecommendationsLoadingState(LoadingState.DONE);
        setRecommendedProductFamilies(recommendationsResult.data.data);
      }
    }

    fetchRecommendedFamilies();

    return () => {
      ignore = true;
    };
  }, [selectedTechniqueName]);

  return { recommendationsLoadingState, recommendedProductFamilies };
};
